module.exports = __webpack_public_path__ + "static/media/problem.c04772e8.svg";